module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_allocate7-5eafbcb46433fc1f38dd8f182397426c.png";